module.exports = __webpack_public_path__ + "static/media/crowne-plaza-dublin-airport.4cf3f5d5.png";